import { makeHighPriorityStyles } from 'utils/stylesWrapper';

export const useZohoSettingsStyles = makeHighPriorityStyles(() => ({
    field: {
        width: '100%',
        maxWidth: '750px',
    },
}));
